// ============================================================
// Sign-in that starts in one browser and finishes in another.
// ------------------------------------------------------------
// Supabase's PKCE flow keeps a one-time secret (the "code verifier") in the
// browser that STARTED the sign-in, and needs it again in the browser that
// FINISHES it. When those are different browsers the exchange fails with
// "PKCE code verifier not found in storage".
//
// The common way in: someone opens boothapp.co from Instagram (or Facebook,
// TikTok...), signs up or taps Google inside that app's built-in browser,
// and the confirmation email or Google hands them back to Safari, which
// never saw the secret. The email is already confirmed by then; they only
// need to sign in where they are. So that case goes to the sign-in page
// with a plain line, never to an error screen.
// ============================================================

/** The exchange failed because this browser never started the sign-in. */
export function isMissingCodeVerifier(message: string | null | undefined): boolean {
  return !!message && /code[ _]verifier|pkce/i.test(message)
}

export const FINISH_SIGN_IN_MESSAGE = "Almost done. Sign in here to finish."

/** /auth/login with the plain line above. */
export function finishSignInPath(): string {
  return `/auth/login?message=${encodeURIComponent(FINISH_SIGN_IN_MESSAGE)}`
}
